import React, { useContext, useEffect, useState } from "react";
import { Form, Row, Col, Button, Table, Card } from "react-bootstrap";
import { BiUpload } from "react-icons/bi";
import { FaRegEnvelope, FaRegEye } from "react-icons/fa";
import { useNavigate, useParams } from "react-router-dom";
import { UserContext } from "../../context/UserContextProvider";
import APIServicenew from "../../utils/APIGeneralService";
import { ToastContainer, toast } from "react-toastify";

const AddRole = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [role, setRole] = useState({
    name: "",
    status: "Active",
    permissions: [],
  });
  const [updaterole, setUpdaterole] = useState({
    name: "",
    status: "Active",
    permissions: [],
  });
  const [menuItems, setMenuItems] = useState([]);
  const [errors, setErrors] = useState({});
  const APIServices = new APIServicenew(process.env.REACT_APP_OTHER_API_URL);
  const authToken = process.env.REACT_APP_authToken;
  const { accessToken, logout } = useContext(UserContext);
  const headers = { "auth-token": authToken, authorization: accessToken };

  useEffect(() => {
    fetchMenuData();
    if (id) {
      fetchRoleData(id);
    }
  }, [id]);

  const fetchMenuData = async () => {
    try {
      const response = await APIServices.get(
        "/admin/auth/get_perission_sections",
        headers
      );
      if (response?.data?.status) {
        const menuData = response?.data?.list.map((item) => ({
          ...item,
          children: Array.isArray(item.children) ? item.children : [],
        }));
        setMenuItems(menuData);
      } else if (response?.status === 401) {
        logout();
        navigate("/");
      } else {
        console.error("Error: ", response?.data.message);
      }
    } catch (error) {
      console.error("Error fetching menu data:", error);
    }
  };

  const fetchRoleData = async (roleId) => {
    try {
      const response = await APIServices.get(
        `/admin/auth/get_role/${roleId}`,
        headers
      );
      if (response?.data?.status) {
        const roleData = response.data.detail || {};
        setRole({
          name: roleData.name || "",
          status: roleData.status || "Active", 
          permissions: roleData.permissions || [],
        });
        setUpdaterole({
          name: roleData.name || "",
          status: roleData.status || "Active",
          permissions: roleData.permissions || [],
        });
      } else if(response?.status === 401){
        logout();
        navigate("/");
       }else {
        console.error("Error: ", response?.data.message);
      }
    } catch (error) {
      console.error("Error fetching role data:", error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!updaterole.name) newErrors.name = "Name is required.";
    if (updaterole.permissions.length == 0) {
      newErrors.permissions = "At least one permission must be selected.";
    } else {
      const hasViewPermission = updaterole.permissions.some(
        (permission) => permission.view
      );

      if (!hasViewPermission) {
        newErrors.permissions =
          "At least one 'View' permission must be selected.";
      }
    }

    setErrors(newErrors);
    return newErrors;
  };

  const permissions = ["View", "Add", "Edit", "Delete"];

  const handlePermissionChange = (
    menuId,
    permissionType,
    name,
    hasChildren = false,
    e
  ) => {
    const updateState = (prevState) => {
      const updatedPermissions = [...prevState.permissions];
      const permissionKey = permissionType.toLowerCase();

      const updateChildrenPermissions = (parent, isChecked) => {
        const children =
          menuItems.find((item) => item.id === parent.id)?.children || [];
        children.forEach((child) => {
          const childIndex = updatedPermissions.findIndex(
            (perm) => perm.section_id === child.id
          );
          if (childIndex >= 0) {
            updatedPermissions[childIndex] = togglePermission(
              updatedPermissions[childIndex],
              isChecked
            );
          } else {
            updatedPermissions.push(
              togglePermission(
                {
                  section_id: child.id,
                  role_id: prevState.permissions[0]?.role_id,
                  name: child.name,
                  view: isChecked,
                  add: isChecked,
                  edit: isChecked,
                  delete: isChecked,
                },
                isChecked
              )
            );
          }
        });
      };

      const updateParentPermissions = (childId, isChecked) => {
        const parentItem = menuItems.find((item) =>
          item.children?.some((child) => child.id === childId)
        );
        if (parentItem) {
          const parentIndex = updatedPermissions.findIndex(
            (perm) => perm.section_id === parentItem.id
          );
          const allChildrenHaveSameStatus = parentItem.children.every(
            (child) => {
              const childPerm = updatedPermissions.find(
                (perm) => perm.section_id === child.id
              );
              return childPerm ? childPerm[permissionKey] == isChecked : false;
            }
          );

          if (parentIndex >= 0) {
            updatedPermissions[parentIndex] = togglePermission(
              updatedPermissions[parentIndex],
              allChildrenHaveSameStatus
            );
          } else if (allChildrenHaveSameStatus) {
            updatedPermissions.push(
              togglePermission(
                {
                  section_id: parentItem.id,
                  role_id: prevState.permissions[0]?.role_id,
                  name: parentItem.name,
                  view: allChildrenHaveSameStatus,
                  add: allChildrenHaveSameStatus,
                  edit: allChildrenHaveSameStatus,
                  delete: allChildrenHaveSameStatus,
                },
                allChildrenHaveSameStatus
              )
            );
          }
        }
      };

      const togglePermission = (perm, isChecked) => ({
        ...perm,
        [permissionKey]: isChecked,
        ...(permissionType == "view" && {
          add: isChecked,
          edit: isChecked,
          delete: isChecked,
        }),
      });

      const isChecked = !updatedPermissions.find(
        (perm) => perm.section_id == menuId
      )?.[permissionKey];
      const menuIndex = updatedPermissions.findIndex(
        (perm) => perm.section_id == menuId
      );

      if (menuIndex >= 0) {
        updatedPermissions[menuIndex] = togglePermission(
          updatedPermissions[menuIndex],
          isChecked
        );
      } else {
        updatedPermissions.push({
          section_id: menuId,
          role_id: prevState.permissions[0]?.role_id,
          name,
          view: permissionType == "View" ? isChecked : false,
          add: permissionType == "Add" ? isChecked : false,
          edit: permissionType == "Edit" ? isChecked : false,
          delete: permissionType == "Delete" ? isChecked : false,
        });
      }

      if (hasChildren) {
        updateChildrenPermissions({ id: menuId }, isChecked);
      }
      updateParentPermissions(menuId, isChecked);

      return { ...prevState, permissions: [...updatedPermissions] };
    };

    const handlesetpremission = (updatedPermissions) => {
      const permissionMap = updatedPermissions.reduce((map, item) => {
        map[item.section_id] = item;
        return map;
      }, {});

      const mergePermissions = (menu, permissions) => {
        return menu.map((item) => {
          const permission = permissions[item.id];
          if (permission) {
            return {
              ...item,
              view: permission.view,
              add: permission.add,
              edit: permission.edit,
              delete: permission.delete,
              children: item.children
                ? mergePermissions(item.children, permissions)
                : item.children,
            };
          }
          return {
            ...item,
            children: item.children
              ? mergePermissions(item.children, permissions)
              : item.children,
          };
        });
      };

      setUpdaterole({
        ...updaterole,
        permissions: mergePermissions(menuItems, permissionMap),
      });
    };

    setRole((prevRole) => {
      const updatedRole = updateState(prevRole);
      handlesetpremission(updatedRole.permissions);
      return updatedRole;
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUpdaterole({ ...updaterole, [name]: value });

    const updatedErrors = { ...errors, [name]: "" };

    if (updaterole.permissions.length > 0) {
      updatedErrors.permissions = "";
    }

    setErrors(updatedErrors);
  };

  const handleSubmit = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        const response = await APIServices.post(
          `/admin/auth/add_role`,
          updaterole,
          headers
        );
        if (response?.data?.status === true) {
          showToast(response?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate("/admin/role-list");
          }, 2000);
        } else {
          showToast(
            response?.data?.message || "Something went wrong.",
            "error"
          );
        }
      } catch (error) {
        showToast("Something went wrong.", "error");
      }
    }
  };

  const handleUpdate = async () => {
    const validationErrors = validateForm();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
    } else {
      try {
        // return
        const payload = { ...updaterole, id };
        const response = await APIServices.post(
          `/admin/auth/update_role`,
          payload,
          headers
        );
        if (response?.data?.status === true) {
          showToast(response?.data?.message || "Success", "success");
          setTimeout(() => {
            navigate("/admin/role-list");
          }, 2000);
        } else {
          showToast(
            response?.data?.message || "Something went wrong.",
            "error"
          );
        }
      } catch (error) {
        showToast("Something went wrong.", "error");
      }
    }
  };

  const showToast = (message, type) => {
    toast(message, {
      position: "top-right",
      autoClose: 2000,
      type,
      hideProgressBar: false,
      closeOnClick: true,
    });
  }; 

  return (
    <>
      <div className="momList_inner todo_list_inner add_channel_sec add_roll_sec">
        <div className="addmom_header d-flex justify-content-start mb-3">
          <h1 className="font_blue_18 font-600">
          {id ? "Edit Role & Permission" : "Assign Role & Permission"}
          </h1>
        </div>

        <Card className="add_channel_form">
          <Card.Body>
            <Form className="">
              <Row>
                <Col md={12} lg={12}>
                  <Form.Group controlId="firstName">
                    <Form.Label className="font_blue_14 font-500 mb-2 ">
                      Role Name
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Role Name"
                      name="name"
                      value={updaterole.name}
                      onChange={handleChange}
                    />
                    {errors.name && (
                      <div className="text-danger">{errors.name}</div>
                    )}
                  </Form.Group>
                </Col>
              </Row>
              <div className="todoList_table mt-4">
                <h4 className="font_blue_18 gont-600">Role Permissions</h4>
                {errors.permissions && (
                  <div className="text-danger">{errors.permissions}</div>
                )}
                <div className="table-responsive">
                  <Table>
                    <thead>
                      <tr>
                        <th>Catalogues</th>
                        <th>View</th>
                        <th>Create</th>
                        <th>Edit</th>
                        <th>Delete</th>
                      </tr>
                    </thead>
                    <tbody>
                      {menuItems.map((menuItem) => (
                        <React.Fragment key={menuItem.id}>
                          <tr >
                            <td>{menuItem.name}</td>
                            {permissions.map((perm) => (
                              <td key={perm} className="">
                                <Form.Check
                                  type="checkbox"
                                  checked={
                                    !!role.permissions.find(
                                      (p) => p.section_id == menuItem.id
                                    )?.[perm.toLowerCase()]
                                  }
                                  onChange={(e) =>
                                    handlePermissionChange(
                                      menuItem.id,
                                      perm,
                                      menuItem.name,
                                      !!menuItem.children.length,
                                      e
                                    )
                                  }
                                  disabled={
                                    perm !== "View" &&
                                    !role.permissions.find(
                                      (p) => p.section_id == menuItem.id
                                    )?.view
                                  }
                                />
                              </td>
                            ))}
                          </tr>
                          {menuItem.children.map((child) => (
                            <tr key={child.id} style={{ paddingLeft: "40px" }}>
                              <td>{child.name}</td>
                              {permissions.map((perm) => (
                                <td className='table-checkbox' key={perm}>
                                  <Form.Check
                                    type="checkbox"
                                    checked={
                                      !!role.permissions.find(
                                        (p) => p.section_id == child.id
                                      )?.[perm.toLowerCase()]
                                    }
                                    onChange={() =>
                                      handlePermissionChange(child.id, perm, child.name)
                                    }
                                    disabled={
                                      perm !== "View" &&
                                      !role.permissions.find(
                                        (p) => p.section_id == child.id
                                      )?.view
                                    }
                                  />
                                </td>
                              ))}
                            </tr>
                          ))}
                        </React.Fragment>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </div>

              <div className="d-flex justify-content-end gap-2">
                <Button
                  className="btn blue_border"
                  onClick={() => navigate("/admin/role-list")}
                >
                  Cancel
                </Button>
                <Button className="btn red_button" onClick={id ? handleUpdate : handleSubmit}>
                {id ? "Update" : "Add"}
                </Button>
              </div>
            </Form>
          </Card.Body>
        </Card>
      </div>
      <ToastContainer />
    </>
  );
};

export default AddRole;
